<template>
    <div class="card tour-extended-card">
        <div class="card-header" :style="'background-image: url(' + (tour.media_tours.length ? tour.media_tours[0].fullUrl : './assets/images/backgrounds/tour-3.png') + ')'">
            <div class="actions">
                <a href="javascript:void(0);" class="btn rounded-pill btn-secondary me-1" @click="addToCart()">Book now</a>
                <a :href="'/' + pageSlug + '/' + tour.slug" class="btn  rounded-pill btn-light">Read more <span class="bi bi-chevron-right"></span></a>
            </div>
            <div class="price">
                <span class="price-num">{{ tour.price | filterPrice(0) }}</span>
            </div>
        </div>
        <div class="card-body text">
            <div class="tour-title">
                <ChalkDecoration >
                    <h3>{{ tour.name }}</h3>
                </ChalkDecoration>
            </div>
        </div>
    </div>
</template>

<script>
import TourAttributes from "../TourAttributes";
import ChalkDecoration from "../elements/ChalkDecoration";
import {mapActions} from "vuex";
import ApiRequest from "../../../utils/api-request";
import TourItem from "../../../models/TourItem";
import FareHarborMixin from "../../../mixins/FareHarborMixin";
import PageLayoutContentMixin from "../../../mixins/ContentMixin";
export default {
    name: "TourExtendedCard",
    mixins: [FareHarborMixin],
    components: {ChalkDecoration, TourAttributes},
    props: {
        tour: {
            type: Object,
            required: true
        },
        pageSlug: {
            type: String,
            default: 'tour'
        }
    },
    methods: {
        ...mapActions('cart', ['addTour']),
        addToCart() {
            if (this.fareHarborMode()) return this.openFareHarborModal();
            new ApiRequest().getTourById(this.tour.id).then(
                (response) => {
                    this.addTour(new TourItem(response.data.tour)).then(res => {

                        if (res) {
                            this.$notify({
                                title: 'Great choice!',
                                text: '«' + this.tour.name + '» is waiting for you!',
                                duration: -1
                            });
                            setTimeout(() => {
                                window.location.href = '/checkout';
                            }, 2000);
                            return;
                        }

                        this.$notify({
                            title: 'Oops!',
                            text: 'Something went wrong...'
                        });
                    });
                }
            )

        }
    }
}
</script>

<style scoped>

</style>
